export default __webpack_public_path__ + "static/N0303-1b7766a0cd0ed63993b1e3ad760b1ee4.png";